module.exports = __webpack_public_path__ + "static/media/secondBlockRetail@2x.775fd15c.jpg";